<template>
  <table>
    <tr v-for="(reference, index) in formattedReferences" :key="index" class="pb-3">
      <td class="px-2 pb-3">[{{index + 1}}]</td>
      <td class="pb-3" v-html="reference" />
    </tr>
  </table>
</template>

<script>
import formatACS from '@/plugins/citation'

export default {
  name: "References",
  props: [
      'references'
  ],
  data: () => ({
    formattedReferences: [],
  }),
  mounted () {
      this.formattedReferences = this.references.map(reference => formatACS(reference))
  }
}
</script>

<style scoped>

</style>